import React from 'react'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
/**
 * @author Pragya Gupta
 */

const front = (concept) => {
  switch (concept) {
    case 'ETUSIVU':
      return 'nav2.etu'
    case 'ASIAKKAAT':
      return 'nav2.hin'
    case 'UUSI_LASKUT':
      return 'nav2.uusi_laskut'
    case 'LASKUT':
      return 'nav2.kysy'
    case 'KULUT':
      return 'nav2.kevy'
    case 'PALKAT':
      return 'nav2.yhteys'
    case 'PROFILE':
      return 'dashboard.asetu'
    case 'OPENFORWORK':
      return 'nav2.openwork'
  }
}

const NavIcon = ({
  name,
  size,
  sectionClass,
  iconClass,
  content,
  userLogged
}) => (
  <Translation>
    {(t) => {
      return (
        <div
          className={
            mobileView && userLogged !== false
              ? 'mobile-nav-icon'
              : sectionClass
          }
        >
          {' '}
          {/* userLogged is passed as false in Navigation component */}
          <FontAwesome name={name} size={size} className={iconClass} />
          <p style={{ fontSize: '14px', maxWidth: '80px' }}>
            {t(front(content))}
          </p>
        </div>
      )
    }}
  </Translation>
)
export default NavIcon
